import i18n from '@/i18n'
import formatDate from '@/helpers/date-helpers/format-date'
import store from '@/store'

import { KILO_BASE_2 } from '@/consts'

export default function  addDetailsToCustomerAddon(addon) {
    if (addon.PlanType == "mobileDailyRoamingAddon") {
        return {...addon, details: {}, description: {}, expiry: {}, is_mobile_daily_roaming_addon: true }
    }

    const details = {};

    if (addon.UsageRuleDataMB == 'Unlimited') {
        details[`${i18n.t('data')}:`] = { value:  i18n.t('unlimited') };
    } else {
        if (addon.TotalDataMB && !isNaN(addon.TotalDataMB) && +addon.TotalDataMB !== 0) {
            const data_initial = +addon.TotalDataMB
    
            const data_to_show = data_initial >= KILO_BASE_2 
                            ? Number.isInteger(data_initial / KILO_BASE_2)
                                ? `${(data_initial / KILO_BASE_2).toFixed(0)} ${i18n.t('unit.GB')}`
                                : `${(data_initial / KILO_BASE_2).toFixed(2)} ${i18n.t('unit.GB')}`
                            : `${data_initial} ${i18n.t('unit.MB')}`
    
            details[`${i18n.t('data')}:`] = { value:  data_to_show };
        } 
    }
    if (addon?.Tethering == true  && store.getters.show_hotspot) {
        details[`${i18n.t('hotspot')}:`] = { value: i18n.t('included') };
    }
    const sub_infos = []

    let data_speed
    let data_speed_dl = 'Unlimited'
    let data_speed_ul = 'Unlimited'
    if (addon.SpeedLimitDL && addon.SpeedLimitDL != 'Unlimited') {
        data_speed_dl = `${addon.SpeedLimitDL}bps`
    }
    if (addon.SpeedLimitUL && addon.SpeedLimitUL != 'Unlimited') {
        data_speed_ul = `${addon.SpeedLimitUL}bps`
    }
    if (data_speed_dl == 'Unlimited' && data_speed_ul == 'Unlimited') {
        data_speed = "In-bundle data at your plan's speed"
    } else if (data_speed_dl == data_speed_ul) {
        data_speed = `Speeds capped at ${data_speed_dl} down + up`
    } else {
        data_speed = `Speeds capped at ${data_speed_dl} down / ${data_speed_ul} up`
    }
    if (data_speed) {
        sub_infos.push(data_speed)
    }

    if (addon.UsageRuleDataMB == 'Throttled') {
        let data_capped

        switch (addon.Throttle) {
            case 'Throttle1.2M1.2M':
                data_capped = `Additional Endless Data capped at 1.2Mbps`
                break;
            case 'Throttle2.0M2.0M':
                data_capped = `Additional Endless Data capped at 2Mbps`
                break;
            case 'Throttle2M2M':
                data_capped = `Additional Endless Data capped at 2Mbps`
                break;
            case '':
                break;
        }
        if (data_capped) {
            sub_infos.push(data_capped)
        }    
    }

    if (details[`${i18n.t('data')}:`]) {
        details[`${i18n.t('data')}:`] = {...details[`${i18n.t('data')}:`], sub_infos}
    }

    if (addon.UsageRuleVoiceMinutes == 'Unlimited') {
        details[`${i18n.t('voice2')}:`] = i18n.t('unlimited');
    } else {
        if (addon.TotalVoiceMinutes && !isNaN(addon.TotalVoiceMinutes) && +addon.TotalVoiceMinutes !== 0) {
            details[`${i18n.t('voice2')}:`] = `${addon.TotalVoiceMinutes} ${i18n.t('unit.mins')}`;
        }
    }

    if (addon.UsageRuleSMS == 'Unlimited') {
        details[`${i18n.t('SMS2')}:`] = i18n.t('unlimited');
    } else {
        if (addon.TotalSMS && !isNaN(addon.TotalSMS) && +addon.TotalSMS !== 0) {
            details[`${i18n.t('SMS2')}:`] = `${addon.TotalSMS} ${i18n.t('unit.SMS')}`;
        }
    }

    if (addon.UsageRuleMMS == 'Unlimited') {
        details[`${i18n.t('MMS2')}:`] = i18n.t('unlimited');
    } else {
        if (addon.TotalMMS && !isNaN(addon.TotalMMS) && +addon.TotalMMS !== 0) {
            details[`${i18n.t('MMS2')}:`] = `${addon.TotalMMS} ${i18n.t('unit.MMS')}`;
        }
    }

    if (addon.UsageRuleIDDVoiceMinutes == 'Unlimited') {
        details[`${i18n.t('international_voice')}:`] = i18n.t('unlimited');
    } else {
        if (addon.TotalIDDVoiceMinutes && !isNaN(addon.TotalIDDVoiceMinutes) && +addon.TotalIDDVoiceMinutes !== 0) {
            details[`${i18n.t('international_voice')}:`] = `${addon.TotalIDDVoiceMinutes} ${i18n.t('unit.mins')}`;
        }
    }

    if (addon.UsageRuleIDDSMS == 'Unlimited') {
        details[`${i18n.t('international_SMS')}:`] = i18n.t('unlimited');
    } else {
        if (addon.TotalIDDSMS && !isNaN(addon.TotalIDDSMS) && +addon.TotalIDDSMS !== 0) {
            details[`${i18n.t('international_SMS')}:`] = `${addon.TotalIDDSMS} ${i18n.t('unit.SMS')}`;
        }
    }

    const description = {};

    if (addon.Description) 	
        description['text'] = addon.Description;
        

    let dataRolloverAllowed = addon.DataRolloverAllowed;
    if (dataRolloverAllowed === undefined) {

        dataRolloverAllowed = false;
    }

    if (store.getters.show_carryover) {
        details[`${i18n.t('data_rollover')}:`] = dataRolloverAllowed
            ? i18n.t('carryover_included')
            : i18n.t('carryover_not_included');
    }
        
    const expiry = {};

    if (addon.ExpiresAtNanos && !isNaN(addon.ExpiresAtNanos) && +addon.ExpiresAtNanos !== 0)  {
        const expires_at_nanos = addon.ExpiresAtNanos;
        const expires_at_miliseconds = Math.round(+expires_at_nanos/1000000);
        const expire_date = new Date(expires_at_miliseconds);
        expiry['date'] = `${i18n.t('next_payment_and_plan_updating')} ${formatDate(expire_date, 'DD MMM YYYY')}`;
        expiry['renewal_date'] = `${i18n.t('next_renewal_date')} ${formatDate(expire_date, 'DD/MM/YYYY')}`;
    }

    return {...addon, details, description, expiry, };
};